import React, { useState } from "react";
import { Link } from 'react-router-dom';
import {  useLocation } from "react-router";
import EmailInput from "../../components/Inputs/EmailInput";
import PasswordInput from "../../components/Inputs/PasswordInput";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import useApp from '../../store/app/appContext';
import { SERVER_BASE_URL } from '../../config';
import DividerSimple from "../../components/Dividers/DividerSimple";
import DividerWithLabel from "../../components/Dividers/DividerWithLabel";
import SignInWithService from "../../components/Buttons/SignInWithService"; 


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function LoginForm() {
  let query = useQuery();
  const email = query.get('email');
  const scanandgo = query.get('scanandgo');

  const [user, _setUser] = useState({
    email: '',
    password: ''
  })
  
  const setUser = (newVal) => _setUser({ ...user, ...newVal})
  const [loginType, setLoginType] = React.useState(null)

  const resetLoginType = () => {
    setUser({
      email: '',
      password: ''
    })
    setLoginType(null);
  }
  

  React.useEffect(() => {
    if (email) {
      setLoginType('email');
      setUser({
        email: email
      })
    }
  }, []);
  
  const {  
    login,
    getLoginType,
  } = useApp();
  
  const handleEmailKeyPress = async (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        const login = await getLoginType(user.email);
        if (login) setLoginType(login.loginType);
    }       
  }
  const handlePwKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      login(user);
    }       
  }

  const handleEmailSubmit = async () => {
    const login = await getLoginType(user.email);
    if (login) setLoginType(login.loginType);
  }
  
  const redirectToCalendly = () => {
    window.location.replace(`${SERVER_BASE_URL}/oauth/calendly`);
  }
  const redirectToGoogle = () => {
    window.location.replace(`${SERVER_BASE_URL}/oauth/google`);
  }

  return (
    <>
      {(!loginType || Object.keys(loginType).length === 0) && 
      <div className="w-full md:max-w-400">
        <div className='w-full mb-4'>
          <p tabIndex={0} role="heading" aria-level="1" aria-label="Login to your account" className="text-2xl md:text-4xl text-secondary">
              Login to your account
          </p>
          <p className="text-xs md:text-sm xl:mt-4 mt-2 leading-none w-full text-secondary">
            Don't have an account?{" "}
            <span tabIndex={0} role="link" aria-label="Login here" className="text-sm font-medium leading-none underline text-gray-800 cursor-pointer">
                {" "}
                <Link to={`${scanandgo ? "/register?scanandgo=true" : "/register"}`}> Sign up here </Link>
            </span> 
          </p>
        </div>
        <div className="grid grid-cols-1 mt-2">
          <EmailInput value={user.email} placeholder={'Enter your email'} onKeyPress={handleEmailKeyPress} onChange={(e) => setUser({ email: e.target.value })}/>
          <PrimaryButton className="mt-4" large onClick={handleEmailSubmit} text={'Login'}/>
        </div>
        <div className='py-2'>
          <DividerWithLabel label='or'/>
        </div>
        <div className='grid grid-cols-1 gap-y-4'>
          <SignInWithService service='google' text='Sign in with Google' onClick={redirectToGoogle} />
          <SignInWithService service='calendly' text='Sign in with Calendly' onClick={redirectToCalendly} />
        </div>
      </div>
      }
      {loginType === 'calendly' && 
      <div className="w-full md:max-w-400">
        <div className='w-full'>
          <p tabIndex={0} role="heading" aria-level="1" aria-label="Login to your account" className="text-xl md:text-4xl text-secondary">
              Login to your account
          </p>
          <p className="text-xs md:text-sm xl:mt-4 mt-2 leading-none w-full text-secondary">
            This email uses Calendly to sign in. 
              {" "}
            <span tabIndex={0} onClick={resetLoginType} role="link" className="text-sm font-medium leading-none underline text-gray-800 cursor-pointer">
              Go back 
            </span> 
          </p>
        </div>
        <DividerSimple/>
        <SignInWithService service='calendly' text='Sign in with Calendly' onClick={redirectToCalendly} />
      </div>
      }
      {loginType === 'google' && 
      <div className="w-full md:max-w-400">
        <div className='w-full'>
          <p tabIndex={0} role="heading" aria-level="1" aria-label="Login to your account" className="text-xl md:text-4xl text-secondary">
              Login to your account
          </p>
          <p className="text-xs md:text-sm xl:mt-4 mt-2 leading-none w-full text-secondary">
            This email uses Google to sign in. 
              {" "}
            <span tabIndex={0} onClick={resetLoginType} role="link" className="text-sm font-medium leading-none underline text-gray-800 cursor-pointer">
              Go back 
            </span> 
          </p>
        </div>
        <DividerSimple/>
        <SignInWithService service='google' text='Sign in with Google' onClick={redirectToGoogle} />
      </div>
      }
      {loginType === 'email' && 
      <div className="w-full md:max-w-400">
        <div className='w-full mb-4'>
          <p tabIndex={0} role="heading" aria-level="1" aria-label="Login to your account" className="text-xl md:text-4xl text-secondary">
              Login to your account
          </p>
          <p className="text-xs md:text-sm xl:mt-4 mt-2 leading-none w-full text-secondary">
            Enter your password.
            {" "}
            <span tabIndex={0} onClick={resetLoginType} role="link" className="text-sm font-medium leading-none underline text-gray-800 cursor-pointer">
              Go back 
            </span> 
          </p>
        </div>
        <div className="grid grid-cols-1 mt-2 gap-y-2">
          <PasswordInput value={user.password} placeholder={'Enter your password'} onKeyPress={handlePwKeyPress} onChange={(e) => setUser({ password: e.target.value })}/>
          <PrimaryButton className="mt-8" large onClick={() => login(user)} text={'Login'}/>
        </div>
      </div>
      }
    </>
  )
};

export default LoginForm;
    